'use strict';

// Log when the script starts
console.log("Script started, waiting for kampyleLoaded event...");

// Function to execute when kampyleLoaded is detected
function userwayButtonStyleChange() {
    clearTimeout(timeoutHandle);  // Clear the timeout once the event is detected
    console.log("kampyleLoaded event detected!");

    // Find the element with id 'userwayIcon'
    var userwayIcon = document.getElementById('userwayIcon');

    // Find the element with id 'nebula_div_btn'
    var nebulaButton = document.getElementById('nebula_div_btn');

    // Check if nebulaButton exists
    if (nebulaButton) {
        console.log("nebula_div_btn found.");

        // Get the position of nebulaButton (bottom) and its height
        var nebulaButtonStyles = window.getComputedStyle(nebulaButton);
        var nebulaButtonBottom = parseFloat(nebulaButtonStyles.bottom);
        var nebulaButtonHeight = parseFloat(nebulaButtonStyles.height);

        // If userwayIcon exists, adjust its position relative to nebulaButton
        if (userwayIcon) {
            // Set the visibility of userwayIcon to visible
            userwayIcon.style.visibility = 'visible';
            // Set the bottom of userwayIcon 8px above nebulaButton, considering its height
            userwayIcon.style.bottom = Math.ceil(nebulaButtonBottom + nebulaButtonHeight - 125) + "px";
            console.log("Styles applied to userwayIcon, positioned 8px above nebula_div_btn.");
        } else {
            console.error("Element with id 'userwayIcon' not found.");
        }

        console.log("Styles applied to nebula_div_btn.");
    } else {
        console.error("Element with id 'nebula_div_btn' not found.");
    }

    console.log("Execution of userwayButtonStyleChange completed.");
}

// Fallback function to handle the case where kampyleLoaded is not detected
function handleEventNotDetected() {
    console.log("kampyleLoaded event was not detected within 10 seconds.");
}

// Set a timeout to trigger if the event isn't detected in 10 seconds
var timeoutHandle = setTimeout(handleEventNotDetected, 10000);
// Adding kampyleLoaded event listener (compatible with modern browsers and IE11)
if (document.addEventListener) {
    document.addEventListener('kampyleLoaded', userwayButtonStyleChange);
} else if (document.attachEvent) {  // IE11 support
    document.attachEvent('onkampyleLoaded', userwayButtonStyleChange);
}

// Log that the script is waiting for the event
console.log("Waiting for kampyleLoaded event...");